var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component"},[(_vm.graphData!=undefined)?_c('apexchart',{attrs:{"width":"90%","height":'90%',"type":"line","options":_vm.graphOptions,"series":_vm.graphData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }